import useSpaPageviews from "./useSpaPageviews"

export default function AnalyticsMount() {
  useSpaPageviews()
  return null
}
